import { render, staticRenderFns } from "./OtherPlan.vue?vue&type=template&id=6b9e0c40&scoped=true"
import script from "./OtherPlan.vue?vue&type=script&lang=js"
export * from "./OtherPlan.vue?vue&type=script&lang=js"
import style0 from "./OtherPlan.vue?vue&type=style&index=0&id=6b9e0c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9e0c40",
  null
  
)

export default component.exports